{
    angular.module('interfaceModule')
        .controller('RefundDetailController',RefundDetailController);
    RefundDetailController.$inject = ['$scope','request.order','utils.constant','$stateParams'];
    function RefundDetailController($scope,orderRequest,constant,$stateParams) {
        let vm=this;
        let collect={
            'activate':activate,
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,
            'refundInfo':null
        };

        vm.collect=collect;
        activate();

		function activate(){
        	//console.log($stateParams.orderId);
			
			getOrderInfo();

        	orderRequest.getRefundDetail($stateParams.orderId)
	        	.then(function(data){
	        		//console.log(data);

	        		collect.refundInfo=data.refundInfo;

	        	})
            
            
        }

        function getOrderInfo(){
            // common.loading.show();
            orderRequest.getOrderInfo($stateParams.orderId)
            .then(function(data){
                //console.log(data);
                collect.docInfo=data.docInfo;
                collect.printInfo=data.printInfo;
                collect.orderInfo=data.orderInfo;

            })
        }
    }
    
}